import React from "react";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });
import { HeadModule } from "@/layouts/styles/ssr.style";
import groovyWalkAnimation from "../../public/animation_empty.json";

function Nodata() {
    return (
        <div className="flex flex-col items-center">
            <Lottie animationData={groovyWalkAnimation} loop={true} />
            <HeadModule>Ohh ! Có vẻ như không có dữ liệu</HeadModule>
        </div>
    );
}

export default Nodata;
